import React from 'react'

function TabList({ children }) {
  return (
    <>{children}</>
  )
}

export default TabList